import { LingodaLogo } from '@lingoda/logotype';
import { Toolbar } from '@lingoda/ui';
import { isAuthStatusUnauthenticatedSelector } from '@lingoda/auth';
import { useSelector } from '@lingoda/hooks';
import { RouterLink, loginPath, studentHomePath } from '@lingoda/router';

interface Props {
    logoIsIcon?: boolean;
    unClickable?: boolean;
    disabledLogo?: boolean;
}

export const SimpleHeader = ({ logoIsIcon, unClickable, disabledLogo }: Props) => {
    const isUnauthenticatedUser = useSelector(isAuthStatusUnauthenticatedSelector);
    const width = logoIsIcon ? 32 : 100;

    return (
        <Toolbar data-testid="simple-header">
            {unClickable ? (
                <LingodaLogo isIcon={logoIsIcon} white={false} width={width} />
            ) : disabledLogo ? (
                <LingodaLogo isIcon={logoIsIcon} white={false} width={width} />
            ) : (
                <RouterLink to={isUnauthenticatedUser ? loginPath() : studentHomePath()}>
                    <LingodaLogo isIcon={logoIsIcon} white={false} width={width} />
                </RouterLink>
            )}
        </Toolbar>
    );
};
